// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"Ei-z","itemsContainer":"Fi-z"};